export * from "./types.js";
export * from "./copy.js";
export {
  takeHome,
  payRiseMarginal,
  helpNotWithheldWarning,
  withholdingGap,
  secondJobWithholding,
  assertNoHandoff,
} from "./calculate.js";
export { fy2025_26, type TakeHomeRuleSet } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import { fy2025_26, type TakeHomeRuleSet } from "./fy2025-26.js";

/** Registry of take-home rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the right rules. */
export const TAKE_HOME_RULESETS: Record<string, TakeHomeRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the take-home ruleset for a financial year, or throw if unknown. */
export function takeHomeRulesFor(fy: FinancialYear): TakeHomeRuleSet {
  const rules = TAKE_HOME_RULESETS[fy];
  if (!rules) {
    throw new Error(`no take-home ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent take-home ruleset — the default for live "this year" calcs. */
export const TAKE_HOME_CURRENT_FY: FinancialYear = "2025-26";
